export default "__VITE_ASSET__LcUitCHU__"